import React from 'react';

/** The site's logo mark (same path as LogoCircle in Icons.tsx), viewBox 41×46. */
const LOGO_MARK =
    'M10.694 9.964C.613 19.196-.189 19.94-.163 20.108c.019.097.41 3.74.866 8.1.462 4.361.853 7.99.873 8.075l.025.142h14.407l2.534-2.556 2.535-2.555H7.25V20.34l7.36-6.373c4.042-3.5 7.373-6.366 7.399-6.366.019 0 2.63 2.866 5.794 6.366l5.756 6.367V31.153l-6.763 6.825-6.77 6.825-.135.544c-.077.297-.122.55-.11.563.02.02 20.978-15.521 21.21-15.728a570.3 570.3 0 0 0-.469-5.15l-.481-5.13-.379-.395c-.205-.214-4.267-4.594-9.022-9.737-4.755-5.144-8.74-9.446-8.85-9.563L21.584 0l-10.89 9.964Z';

/**
 * Comment avatars as inline SVG (they were two PNGs, 4–7 KB each, loaded through the image
 * optimizer for every comment): staff = logo on navy, visitor = neutral silhouette.
 */
const CommentAvatar: React.FC<{ admin?: boolean; className?: string }> = ({ admin, className }) =>
    admin ? (
        <svg viewBox='0 0 36 36' className={className} role='img' aria-label='خانه سرمایه'>
            <circle cx='18' cy='18' r='18' fill='#030038' />
            <path transform='translate(9.4 8.3) scale(0.42)' fill='#fff' d={LOGO_MARK} />
        </svg>
    ) : (
        <svg viewBox='0 0 36 36' className={className} role='img' aria-label='کاربر'>
            <circle cx='18' cy='18' r='18' className='fill-gray-200 dark:fill-white/15' />
            <circle cx='18' cy='14' r='6' className='fill-gray-400 dark:fill-white/45' />
            <path
                d='M6.6 31.4C8.2 26 12.7 23 18 23s9.8 3 11.4 8.4A17.9 17.9 0 0 1 18 36a17.9 17.9 0 0 1-11.4-4.6Z'
                className='fill-gray-400 dark:fill-white/45'
            />
        </svg>
    );

export default CommentAvatar;
